import { render } from "./Mentions.vue?vue&type=template&id=43b3f239&ts=true"
import script from "./Mentions.vue?vue&type=script&lang=ts"
export * from "./Mentions.vue?vue&type=script&lang=ts"

import "./Mentions.vue?vue&type=style&index=0&id=43b3f239&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__